import classNames from 'classnames';
import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/types/store-types';
import { MediaManager } from '../../../manager/MediaManager';
import './styles.scss';

type Props = {
  settings: {
    priority: number;
    imageSrc: string;
    type: string;
    extension: string;
    classname: string;
    link: string;
    styles: Styles;
    website?: string;
  };
};
const Licence: FC<Props> = ({ settings }) => {
  const { styles, type, extension, classname, imageSrc, link } = settings;

  const { generalConfigs } = useSelector((state: RootState) => state.configs);

  const licenceComonent = useMemo(() => {
    if (type === 'iframe') {
      return <iframe title="licence" src={generalConfigs?.gambleLicence ?? ''} style={styles}></iframe>;
    }

    if (type === 'image') {
      return (
        <img
          src={`/images/footer/licence.${extension || 'svg'}`}
          className={classNames(classname, 'image_licence')}
          alt="licence"
        />
      );
    }

    if (type === 'composicao') {
      return (
        <a
          style={styles}
          href={link}
          target="_blank"
          className="composicao_icon"
          aria-label="Learn more about Ministério da Fazenda"
        >
          <img src={MediaManager.getSrcFromMediaAssets(imageSrc, '/')} alt="Ministério da Fazenda" />
        </a>
      );
    }

    return (
      <a
        style={styles}
        href={generalConfigs?.gambleLicence ?? ''}
        target="_blank"
        aria-label="Learn more about Curacao"
      >
        <img src={imageSrc || '/images/license.png'} alt="Licence" />
      </a>
    );
  }, [settings]);

  return <div className={'licence_wrapper'}>{licenceComonent}</div>;
};
export default Licence;
